/*
 * Tutorial Details Page Messages
 *
 * This contains all the text for the Tutorial Details Page component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.TutorialDetailsPage';

export default defineMessages({
  tutorialDetailsSectionTitle: {
    id: `${scope}.tutorialDetailsSectionTitle`,
    defaultMessage: 'Tutorial Details',
  },
  tutorialQuestionsSectionTitle: {
    id: `${scope}.tutorialQuestionsSectionTitle`,
    defaultMessage: 'Tutorial Questions',
  },
  codeLabel: {
    id: `${scope}.codeLabel`,
    defaultMessage: 'Code',
  },
  titleEnLabel: {
    id: `${scope}.titleEnLabel`,
    defaultMessage: 'Title (en)',
  },
  titleDeLabel: {
    id: `${scope}.titleDeLabel`,
    defaultMessage: 'Title (de)',
  },
  kindLabel: {
    id: `${scope}.kindLabel`,
    defaultMessage: 'Type   ',
  },
  cohortLabel: {
    id: `${scope}.cohortLabel`,
    defaultMessage: 'Cohort',
  },
  titleEnColumnLabel: {
    id: `${scope}.titleEnColumnLabel`,
    defaultMessage: 'Title (en)',
  },
  titleDeColumnLabel: {
    id: `${scope}.titleDeColumnLabel`,
    defaultMessage: 'Title (de)',
  },
  codeColumnLabel: {
    id: `${scope}.codeColumnLabel`,
    defaultMessage: 'Code',
  },
  typeColumnLabel: {
    id: `${scope}.typeColumnLabel`,
    defaultMessage: 'Type',
  },
  cohortColumnLabel: {
    id: `${scope}.cohortColumnLabel`,
    defaultMessage: 'Cohort',
  },
  questionEnColumnLabel: {
    id: `${scope}.questionEnColumnLabel`,
    defaultMessage: 'Question (en)',
  },
  questionDeColumnLabel: {
    id: `${scope}.questionDeColumnLabel`,
    defaultMessage: 'Question (de)',
  },
  optionsColumnLabel: {
    id: `${scope}.optionsColumnLabel`,
    defaultMessage: 'Options',
  },
  visibleColumnLabel: {
    id: `${scope}.visibleColumnLabel`,
    defaultMessage: 'Visible',
  },
  yesLabel: {
    id: `${scope}.yesLabel`,
    defaultMessage: 'Yes',
  },
  noLabel: {
    id: `${scope}.noLabel`,
    defaultMessage: 'No',
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage: 'Delete',
  },
  deleteTutorialConfirmation: {
    id: `${scope}.deleteTutorialConfirmation`,
    defaultMessage: 'Are you sure you want to delete this tutorial question?',
  },
  tutorialQuestionDeleted: {
    id: `${scope}.tutorialQuestionDeleted`,
    defaultMessage: 'Tutorial question deleted successfully',
  },
  tutorialQuestionSaved: {
    id: `${scope}.tutorialQuestionSaved`,
    defaultMessage: 'Question saved successfully',
  },
  tutorialOptionSaved: {
    id: `${scope}.tutorialOptionSaved`,
    defaultMessage: 'Selectable value (option) saved successfully',
  },
  tutorialOptionDeleted: {
    id: `${scope}.tutorialOptionDeleted`,
    defaultMessage: 'Selectable value (option) deleted successfully',
  },
});
